<table style="width: 100%; background-color: #f68026; min-height: 50px;">
  <tbody>
  <tr>
  <td style="text-align: center; font-family: Roboto;
  font-weight: 350;
  font-size: 26px;"><span style="color: #ffffff;">&nbsp;Unauthorized!</span></td>
  </tr>
  </tbody>
  </table>